export default "__VITE_ASSET__d2e3f8f2__"